import { call, put, takeEvery } from "redux-saga/effects";

// Redux States
import { Callback_api, Coupen_Code, Dynamic_Pixel, Membership_details, Pay_Now ,Offline_Profile} from '../../Helpers/api_helpers'
import { CALLBACK_DETAIL, COUPEN_CODE, DYNAMIC_PIXEL, MEMBERSHIP_DETAIL, PAY_NOW ,OFFLINE_PROFILE} from './ActionTypes';
import { callBackDetailApiError, callBackDetailSuccess, coupenCodeApiError, coupenCodeSuccess, dynamicPixelApiError, dynamicPixelSuccess, getMemberShipDetailApiError, 
  getMemberShipDetailSuccess, payNowApiError, payNowSuccess ,getOfflineDetailSuccess,getOfflineDetailFail,offlineprofileSuccess} from "./Action";
import Constants from "../../Constants/constants";

function* membershipDetail({ payload: {id,email,fromPage, microtrackId,requestvia,discountCode} }) {
  // const microtrackId = localStorage.getItem('microtrackId');

  try {
    const response = yield call(Membership_details,{
      email:email ?? null,
      userId: id,
      loginFrom: localStorage.getItem(Constants.loginLocalStorageKeys.loginDevice),
      fromPage:fromPage || localStorage.getItem("fromPage"),
      ...(microtrackId && { microtrackId }), // Include microtrackId only if it exists
           ...( requestvia && { requestvia }),  // Include requestvia only if it exists
            ...(localStorage.getItem("eventTrackIdPlan") && { event_clc_track_id: localStorage.getItem("eventTrackIdPlan") }),
            ...(discountCode && { discountCode })

    });
    if (response.data.status === "Success") {
      yield put(getMemberShipDetailSuccess(response));
    } else {
      yield put(getMemberShipDetailApiError(response));
    }
  } catch (error) {
    yield put(getMemberShipDetailApiError(error));
  }
}



function* callBackDetail({ payload: {values,id} }) {
  try {
    const response = yield call(Callback_api,{
      mobileno:values.mobileNo,
      userId:id,
      mothertongue:values.language
    });
    if (response.data.status === "Success") {
      yield put(callBackDetailSuccess(response));
    } else {
      yield put(callBackDetailApiError(response));
    }
  } catch (error) {
    yield put(callBackDetailApiError(error));
  }
}

function* coupenCode({ payload: { values, id, discountCode, fromPage } }) {
  try {
    const response = yield call(Coupen_Code, {
      email: localStorage.getItem(Constants.loginLocalStorageKeys.loginName) == '' ? null : localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      pack: id,
      userId: values,
      discountCode: discountCode,
      ...(fromPage && { fromPage }),
    });
    if (response.data.status === "Success") {
      yield put(coupenCodeSuccess(response));
    } else {
      yield put(coupenCodeApiError(response));
    }
  } catch (error) {
    yield put(coupenCodeApiError(error));
  }
}

//pay now
function* payNowDetail({ payload: {values,id, discountCode} }) {
  try {
   
    const isFromClc = localStorage.getItem("clcpopup") ;
    const clcNotificationId  = localStorage.getItem("clcpopupnotificationId");
    const messageTypeId  = localStorage.getItem("messageTypeId");
    const response = yield call(Pay_Now,{
      email:localStorage.getItem(Constants.loginLocalStorageKeys.loginName) == '' ? null: localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      userId:values,
      pack:id,
      discountapplied: "",
      discount: discountCode,
      ...((isFromClc || messageTypeId==265) && { notificationId: clcNotificationId }),
      phonepack:"" ,
      horopack:"" ,
      timespent:"" ,
      basicpack: ""
    });
    if (response.data.status === "Success") {
      yield put(payNowSuccess(response));
    } else {
      yield put(payNowApiError(response));
    }
  } catch (error) {
    yield put(payNowApiError(error));
  }
}

//dynamic pixel
function* dynamicPixelData({ payload: {} }) {
  try {
    const response = yield call(Dynamic_Pixel,{
      email:localStorage.getItem(Constants.loginLocalStorageKeys.loginName) == '' ? null: localStorage.getItem(Constants.loginLocalStorageKeys.loginName),
      userId:localStorage.getItem(Constants.loginLocalStorageKeys.loginId),
    });
    if (response.data.status === "Success") {
      yield put(dynamicPixelSuccess(response));
    } else {
      yield put(dynamicPixelApiError(response));
    }
  } catch (error) {
    yield put(dynamicPixelApiError(error));
  }
}


function* paymentSaga() {
  yield takeEvery(MEMBERSHIP_DETAIL, membershipDetail);
  yield takeEvery(CALLBACK_DETAIL,callBackDetail);
  yield takeEvery(COUPEN_CODE, coupenCode);
  yield takeEvery(PAY_NOW, payNowDetail);
  yield takeEvery(DYNAMIC_PIXEL, dynamicPixelData);
  // yield takeEvery(OFFLINE_PROFILE, offlineprofile);
}

export default paymentSaga;
